import { render, staticRenderFns } from "./Component.EditAssignment.vue?vue&type=template&id=7e0ecf56&scoped=true&"
import script from "./Component.EditAssignment.vue?vue&type=script&lang=js&"
export * from "./Component.EditAssignment.vue?vue&type=script&lang=js&"
import style0 from "./Component.EditAssignment.vue?vue&type=style&index=0&id=7e0ecf56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0ecf56",
  null
  
)

export default component.exports